import React, { Component } from 'react'

import { ShelfProps } from 'client/shared/types/shelf'

import urlFor, { QueryParams } from 'shared/tools/url-helper'

import Linka from 'client/shared/blocks/linka'
import { UserAvatar } from 'client/shared/blocks/user-avatar'

import './shelf-creator.styl'

type Props = {
  shelf: ShelfProps
  query?: QueryParams
}

export class ShelfCreator extends Component<Props> {
  render(): JSX.Element {
    const { shelf, query } = this.props

    if (shelf.type === 'series') {
      return (
        <div>
          {shelf.authors.map((author, i) => {
            return (
              <Linka
                className="shelf-creator"
                path={urlFor.author(author.uuid, query)}
                key={i}
              >
                <span className="shelf-creator__image">
                  <UserAvatar
                    user={{
                      name: author.name,
                      avatar: author.image,
                    }}
                    size={24}
                    key={i}
                  />
                </span>
                <span className="shelf-creator__name">{author.name}</span>
              </Linka>
            )
          })}
        </div>
      )
    } else {
      const { creator } = shelf
      const content = (
        <>
          <span className="shelf-creator__image">
            <UserAvatar user={creator} size={24} />
          </span>
          <span className="shelf-creator__name">
            {creator.name || creator.login}
          </span>
        </>
      )

      return (
        <Linka
          className="shelf-creator"
          path={urlFor.user(creator.login, query)}
          loginWall
          pseudo
        >
          {content}
        </Linka>
      )
    }
  }
}
